import { render } from "./taskEdit.vue?vue&type=template&id=28541606&scoped=true&ts=true"
import script from "./taskEdit.vue?vue&type=script&lang=ts"
export * from "./taskEdit.vue?vue&type=script&lang=ts"

import "./taskEdit.vue?vue&type=style&index=0&id=28541606&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28541606"]])

export default __exports__